import { call, put, select, takeEvery } from "redux-saga/effects";
import {
  clearCCardInfo,
  updateCCardInfo,
  updateDestination,
  updateDestinationAddress,
  updateLoggedInFlag,
  updatePpuFlag,
  updateTowDistance,
} from "../../../action";
import {
  getCommonBenefits,
  getPartnerDetails,
  getServiceRequestPayload,
  getTowInfo,
} from "../../../selector";
import { getLocationRouterView } from "../../LocationRouter/selectors";
import { getAddressForServiceRequestPayload, parseAddressComponents } from "../../../utils/mapsLocationHelper";
import { getOmniStreamlinedFlag } from "../../../features/FeatureFlags";
import { emitJourneyEvent, JOURNEY_STEP_TYPES } from "../../../utils/journeyMonitoring";

function* confirmDestination() {
  const { experience } = yield select(getPartnerDetails);
  const towInfo = yield select(getTowInfo);
  const commonBenefits = yield select(getCommonBenefits);
  const { serviceRequest } = yield select(getServiceRequestPayload);
  const omniStreamlined = yield select(getOmniStreamlinedFlag);
  const flow = yield select(getLocationRouterView);
  const overMileageEnabled = experience.overMileageEnabled;
  const { distanceFromCurrentLocation, overMileageCost, overMileageDistance, totalTowCost, unitsShorthand } = towInfo;

  emitJourneyEvent(JOURNEY_STEP_TYPES.USER_MILESTONE, "destination_confirmed", {
    distanceFromCurrentLocation,
    overMileageDistance,
    overMileageCost,
    totalTowCost,
    flow,
  });

  if (overMileageDistance > 0) {
    if (commonBenefits.benefits && overMileageEnabled) {
      yield put(updateCCardInfo({ transactionAmount: overMileageCost }));
    }

    yield put(updatePpuFlag("Y"));

    if (commonBenefits.benefits && serviceRequest.loggedIn === "N") {
      yield put(updateLoggedInFlag("Y"));
    }
  } else if (commonBenefits.benefits) {
    yield put(clearCCardInfo());
    yield put(updatePpuFlag("N"));
  }

  if (serviceRequest.ppuFlag === "Y") {
    yield put(
      updateCCardInfo({
        transactionAmount: totalTowCost,
      })
    );
  }

  if (omniStreamlined) {
    yield put(
      updateTowDistance({
        scalar: parseFloat(distanceFromCurrentLocation),
        unitMeasure: unitsShorthand,
      })
    );
  }
}

function* confirmDropoffDestinationSaga(action: ReturnType<typeof updateDestination>) {
  const { payload } = action;

  if (!payload.hasBeenConfirmed) {
    return;
  }

  if (payload.isCustomLocation) {
    const parsedComponents = parseAddressComponents(payload.address_components);
    let formattedAddress = getAddressForServiceRequestPayload(parsedComponents);
    formattedAddress.latitude = payload.geometry.location.lat();
    formattedAddress.longitude = payload.geometry.location.lng();
    yield call(confirmDestination);
    yield put(updateDestinationAddress(formattedAddress));
  } else {
    yield call(confirmDestination);
    yield put(updateDestinationAddress(payload.addressDetails));
  }
}

export function* watchConfirmDropoffDestinationSaga() {
  yield takeEvery("UPDATE_DESTINATION", confirmDropoffDestinationSaga);
}
